import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';

import { defaultHttpTimeoutMs } from '@core/constants';
import {
    BetGeniusError,
    BetGeniusRequest,
    BetGeniusStream,
    getBetGeniusRegion,
} from '@models/streams/BetGenius';
import {
    BetRadarResponse,
    BetRadarError,
} from '@models/streams/BetRadar';
import {
    ImgArenaTokenResponse,
    ImgArenaError,
    ImgArenaResponse,
    ImgArenaRequest,
} from '@models/streams/ImgArena';
import {
    InfrontsportsError,
    InfrontsportsResponse,
} from '@models/streams/Infrontsports';
import {
    PerformTokenResponse,
    PerformError,
} from '@models/streams/Perform';

import { statsBaseURL } from '../constants';
export default class RestService {
    private readonly statsJSONRestClient: RestClient = createRestClient(
        statsBaseURL,
        defaultHttpTimeoutMs,
    );

    public getPerformToken(uuid: string, streamId: string): Promise<PerformTokenResponse | PerformError> {
        return this.statsJSONRestClient.get('/video-stream/statsperform/stream/access-token', {
            params: {
                uuid,
                asset_id: streamId,
            },
        });
    }

    public getImgArenaToken(): Promise<ImgArenaTokenResponse | ImgArenaError> {
        return this.statsJSONRestClient.get('/video-stream/imgarena/stream/access-token');
    }

    // eslint-disable-next-line class-methods-use-this
    public getImgArenaStreamData(streamId: number, requestData: ImgArenaRequest): Promise<ImgArenaResponse | ImgArenaError> {
        const { url, clientId, timems, md5 } = requestData;

        const baseURL = `${url}/api/v2/streaming/events/${streamId}/stream`;

        const imgArenaRestClient = createRestClient(
            baseURL,
            defaultHttpTimeoutMs,
        );

        return imgArenaRestClient.get(
            `${url}/api/v2/streaming/events/${streamId}/stream`,
            {
                params: {
                    operatorId: clientId,
                    auth: md5,
                    timestamp: timems,
                    'page.page': 2,
                    'page.size': 1,
                },
            },
        );
    }

    public getBetRadarStreamData(streamId: number): Promise<BetRadarResponse | BetRadarError> {
        return this.statsJSONRestClient.get('/video-stream/betradar/stream/url', {
            params: {
                stream_id: streamId,
            },
        });
    }

    public getBetGenius(request: BetGeniusRequest): Promise<BetGeniusStream | BetGeniusError> {
        return this.statsJSONRestClient.get('/video-stream/betgenius/stream/url', {
            params: {
                fixture_id: request?.fixtureId,
                stream_id: request?.streamId,
                delivery_id: request?.deliveryId,
                delivery_type: request?.deliveryType,
                device: request?.device,
                user_id: request?.userId,
                region: getBetGeniusRegion(request?.region),
            },
        });
    }

    public getInfrontsportsStreamData(matchId: string, userId: number) {
        return this.statsJSONRestClient.get<InfrontsportsResponse | InfrontsportsError>('/video-stream/infrontsports/stream/url', {
            params: {
                event_id: matchId,
                user_id: userId,
            },
        });
    }
}
